<template>
    <div>
        <b-row>
            <b-col>
                <b-pagination
                    v-if="!confirmationTable"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    style="margin-top: 10px; margin-bottom: -10px"
                ></b-pagination>
            </b-col>
            <b-col>
                <b-input-group size="sm"
                               v-if="!confirmationTable">
                <b-form-input
                    v-model="searchInput"
                    type="search"
                    placeholder="Zum Suchen tippen"
                    @keydown.enter="getData(searchInput)"
                ></b-form-input>
                <b-input-group-append>
                    <b-button :disabled="!searchInput" @click="getData(searchInput)" variant="primary">Suchen</b-button>
                </b-input-group-append>
                <b-input-group-append>
                    <b-button :disabled="!searchInput" @click="searchInput = ''; getData()">Reset</b-button>
                </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>

        <b-table striped hover class="mt-4"
                 :items="members"
                 :fields="cols"
                 :per-page="confirmationTable ? 0 : perPage"
                 :current-page="currentPage"
                 :filter-included-fields="['number']"
        >
            <!--            <template v-slot:cell(edit)="data">-->
            <!--                <b-button @click="deleteUser(data)" variant="primary">Löschen</b-button>-->
            <!--                <b-button class="ml-4" @click="editUser(data)" variant="secondary">Bearbeiten</b-button>-->
            <!--            </template>-->

            <template v-slot:cell(name)="data">
                {{ data.item.gender + " " + data.item.first_name + " " + data.item.last_name }}
            </template>

            <template v-slot:cell(address)="data">
                {{ data.item.zip + " " + data.item.city }}
            </template>

            <template v-slot:cell(contactInfo)="data">

                <a v-if="data.item.email" :href="'mailto:' + data.item.email">{{ data.item.email }}<br></a>
                <a v-if="data.item.phone" :href="'tel:' + data.item.phone">{{ data.item.phone }}<br></a>
                <a v-if="data.item.email_2" :href="'mailto:' + data.item.email_2">{{ data.item.email_2 }}<br></a>
                <a v-if="data.item.phone_2" :href="'tel:' + data.item.phone_2">{{ data.item.phone_2 }}</a>

                <div v-if="data.item.emergency_contacts[0]" style="color: #7a1919">
                    <span>
                        <b>Notfallkontakt:</b><br>
                        {{ data.item.emergency_contacts[0].name }}
                    </span>
                    <a :href="'tel:' + data.item.emergency_contacts[0].phone_number">{{ data.item.emergency_contacts[0].phone_number }}</a>
                </div>

            </template>

            <template v-slot:cell(app_user)="data">
                <div v-if="data.item.app_user" class="appUser" style="background: #008000">Ja</div>
                <div v-else class="appUser" style="background: #ff0000">Nein</div>
            </template>


            <template v-slot:cell(problem)="data">
                <div v-if="data.item.problem === 0" class="status" style="background: #228b22">{{ data.item.status }}</div>
                <div v-else-if="data.item.problem === 1" class="status" style="background: #ff0000">{{ data.item.status }}</div>
                <div v-else class="status" style="background: #787070">{{ data.item.status }}</div>
            </template>

            <template v-slot:cell(report)="data">
                <b-btn @click="report(data.item.number)" variant="primary">Rückmelden</b-btn>
                <b-btn @click="setInactive(data.item.number)" variant="secondary" class="mt-3">Deaktivieren</b-btn>
            </template>
        </b-table>
        <h3 style="text-align: center" v-if="members.length === 0">{{ noDataText }}</h3>
    </div>
</template>
<script>
    export default {
        name: 'member-table',
        props: [
            'dataUrl',
            'confirmationTable'
        ],
        mounted() {
            this.getData();
        },
        methods: {
            report(memberId) {
                this.$api.post('members/' + memberId + '/setlifestatus')
                    .then(() => {
                        this.getData()
                    })
            },
            setInactive(memberId) {
                this.$api.post('members/' + memberId + '/setinactive')
                    .then(() => {
                        this.getData()
                    })
            },
            getData(query = null) {
                    this.$api.get(this.dataUrl,
                        {
                            params: {
                                q: query
                            }
                        }
                    )
                        .then(response => {
                            this.rows = response.data.data.length
                            this.members = response.data.data
                            this.noDataText = 'Keine Einträge vorhanden'
                        })
            },
        },
        data() {
            return {
                perPage: 15,
                currentPage: 1,
                cols: [
                    {
                        key: 'number',
                        label: 'Mitglieds Nr.'
                    },
                    {
                        key: 'name',
                        label: 'Name'
                    },
                    {
                        key: 'address',
                        label: 'Adresse'
                    },
                    {
                        key: 'contactInfo',
                        label: 'Kontaktdaten'
                    },
                    {
                        key: 'app_user',
                        label: 'App-Nutzer',
                        sortable: true
                    },
                    {
                        key: 'problem',
                        label: 'Status',
                        sortable: true
                    },
                    {
                        key: 'report',
                        label: ''
                    }
                ],
                members: [],
                filter: '',
                searchInput: '',
                rows: 0,
                noDataText: 'Lädt ...'
            }
        }
    }
</script>
<style scoped>
    .status {
        width: 200px;
        height: 30px;
        border-radius: 5px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .appUser {
        width: 80px;
        height: 30px;
        border-radius: 5px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>
